if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.videoLabels = {
          play: 'Play',
          pause: 'Pause',
          soundOn: 'Ton an',
          soundOff: 'Ton aus',
          playAria: 'Video abspielen',
          pauseAria: 'Video pausieren',
          unmuteAria: 'Ton einschalten',
          muteAria: 'Ton ausschalten',
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.bindNativeVideoControls();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, preferSound = false) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            //activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia, preferSound);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      syncNativeVideoControls(container) {
        if (!container) return;

        const video = container.querySelector('video');
        if (!video) return;

        const playButton = container.querySelector('[data-product-gallery-video-toggle="play"]');
        const muteButton = container.querySelector('[data-product-gallery-video-toggle="mute"]');
        const overlayButton = container.querySelector('[data-product-gallery-video-overlay]');
        const showOverlay = video.paused;

        container
          .querySelector('[data-product-gallery-video-controls]')
          ?.classList.toggle('product__media-video-controls--visible', !video.paused || !video.muted);

        if (playButton) {
          playButton.textContent = video.paused ? this.videoLabels.play : this.videoLabels.pause;
          playButton.setAttribute('aria-label', video.paused ? this.videoLabels.playAria : this.videoLabels.pauseAria);
          playButton.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
        }

        if (muteButton) {
          muteButton.textContent = video.muted ? this.videoLabels.soundOn : this.videoLabels.soundOff;
          muteButton.setAttribute('aria-label', video.muted ? this.videoLabels.unmuteAria : this.videoLabels.muteAria);
          muteButton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        }

        if (overlayButton) {
          overlayButton.classList.toggle('product__media-play-overlay--hidden', !showOverlay);
          overlayButton.disabled = !showOverlay;
          overlayButton.setAttribute('aria-hidden', showOverlay ? 'false' : 'true');
          overlayButton.setAttribute('aria-label', video.paused ? this.videoLabels.playAria : this.videoLabels.pauseAria);
        }
      }

      bindNativeVideoControls() {
        this.elements.viewer?.querySelectorAll('[data-product-gallery-video]').forEach((container) => {
          if (container.dataset.productGalleryVideoInitialized === 'true') {
            this.syncNativeVideoControls(container);
            return;
          }

          container.dataset.productGalleryVideoInitialized = 'true';

          const video = container.querySelector('video');
          const playButton = container.querySelector('[data-product-gallery-video-toggle="play"]');
          const muteButton = container.querySelector('[data-product-gallery-video-toggle="mute"]');
          const overlayButton = container.querySelector('[data-product-gallery-video-overlay]');

          if (!video) return;

          const sync = () => this.syncNativeVideoControls(container);

          const togglePlayback = () => {
            if (video.paused) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }

            sync();
          };

          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          video.addEventListener('volumechange', sync);

          if (playButton) {
            playButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              togglePlayback();
            });
          }

          if (overlayButton) {
            overlayButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              togglePlayback();
            });
          }

          video.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            togglePlayback();
          });

          if (muteButton) {
            muteButton.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();

              if (video.muted) {
                this.elements.viewer?.querySelectorAll('[data-product-gallery-video] video').forEach((otherVideo) => {
                  if (otherVideo === video) return;
                  otherVideo.defaultMuted = true;
                  otherVideo.setAttribute('muted', 'muted');
                  otherVideo.muted = true;
                  this.syncNativeVideoControls(otherVideo.closest('[data-product-gallery-video]'));
                });

                video.defaultMuted = false;
                video.removeAttribute('muted');
                video.muted = false;

                if (video.paused) {
                  video.play().catch(() => {});
                }
              } else {
                video.defaultMuted = true;
                video.setAttribute('muted', 'muted');
                video.muted = true;
              }

              sync();
            });
          }

          sync();
        });
      }

      playActiveMedia(activeItem, preferSound = false) {
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);

        const activeVideo = activeItem.querySelector('video');
        activeItem.parentElement.querySelectorAll('video').forEach((video) => {
          if (video === activeVideo) return;

          video.pause();
          video.defaultMuted = true;
          video.setAttribute('muted', 'muted');
          video.muted = true;
          this.syncNativeVideoControls(video.closest('[data-product-gallery-video]'));
        });

        if (!activeVideo) return;

        if (preferSound) {
          activeVideo.defaultMuted = false;
          activeVideo.removeAttribute('muted');
          activeVideo.removeAttribute('autoplay');
          activeVideo.muted = false;
          activeVideo
            .play()
            .catch(() => {
              activeVideo.defaultMuted = true;
              activeVideo.setAttribute('muted', 'muted');
              activeVideo.muted = true;
              this.syncNativeVideoControls(activeVideo.closest('[data-product-gallery-video]'));
              return activeVideo.play().catch(() => {});
            });
          this.syncNativeVideoControls(activeVideo.closest('[data-product-gallery-video]'));
          return;
        }

        activeVideo.defaultMuted = true;
        activeVideo.setAttribute('muted', 'muted');
        activeVideo.muted = true;
        activeVideo.play().catch(() => {});
        this.syncNativeVideoControls(activeVideo.closest('[data-product-gallery-video]'));
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
